import { useMemo } from 'react';
import { makeVariablePattern, resolveSystemVariable } from '~/components/AgreementStudioPage/TemplateVariables/TemplateVariables.utils';
export const SMS_VARIANT_KEY = 'sms';
export const STUB_CLIENT_COMPANY_NAME = 'Acme Inc.';
export const STUB_CLIENT_FIRST_NAME = 'John';
export const STUB_CLIENT_LAST_NAME = 'Smith';
export const STUB_CLIENT_EMAIL = 'john@acme.com';
export const STUB_AGREEMENT_NAME = 'Sample Agreement';
export const STUB_EFFECTIVE_DATE = new Date(2025, 0, 1);
export function useNotificationPreviewContext(vendorBusinessName, currentDate) {
    return useMemo(()=>({
            clientCompanyName: STUB_CLIENT_COMPANY_NAME,
            clientFirstName: STUB_CLIENT_FIRST_NAME,
            clientLastName: STUB_CLIENT_LAST_NAME,
            clientEmail: STUB_CLIENT_EMAIL,
            vendorBusinessName,
            agreementName: STUB_AGREEMENT_NAME,
            effectiveDate: STUB_EFFECTIVE_DATE,
            currentDate: currentDate !== null && currentDate !== void 0 ? currentDate : new Date()
        }), [
        vendorBusinessName,
        currentDate
    ]);
}
const normalize = (label)=>label.trim().toLowerCase();
export function resolveSegments(text, apiVariables, context) {
    if (!text) return [];
    const apiByLabel = new Map(Object.entries(apiVariables).map((param)=>{
        let [label, value] = param;
        return [
            normalize(label),
            value
        ];
    }));
    const resolveLabel = (label)=>{
        const apiValue = apiByLabel.get(normalize(label));
        if (apiValue != null && apiValue !== '') return apiValue;
        if (context != null) {
            const systemValue = resolveSystemVariable(label, context);
            if (systemValue != null && systemValue !== '') return systemValue;
        }
        return undefined;
    };
    const segments = [];
    let lastIndex = 0;
    for (const match of text.matchAll(makeVariablePattern())){
        var _match_index;
        const label = match[1].trim();
        const start = (_match_index = match.index) !== null && _match_index !== void 0 ? _match_index : 0;
        if (start > lastIndex) {
            segments.push({
                kind: 'text',
                value: text.slice(lastIndex, start)
            });
        }
        const resolved = resolveLabel(label);
        if (resolved != null) {
            segments.push({
                kind: 'text',
                value: resolved
            });
        } else {
            segments.push({
                kind: 'unresolved',
                label
            });
        }
        lastIndex = start + match[0].length;
    }
    if (lastIndex < text.length) {
        segments.push({
            kind: 'text',
            value: text.slice(lastIndex)
        });
    }
    return segments;
}
const SKELETON_BY_NOTIFICATION = {
    invoiceIssuedAutoProcess: 'invoice',
    invoiceIssuedRequiresApproval: 'invoice',
    adHocInvoiceIssued: 'invoice',
    adHocInvoicePaidConfirmation: 'invoice',
    adHocInvoiceOverdueReminderCustomer: 'invoice',
    invoiceRefundFailedVendor: 'invoice',
    paymentFailedCustomer: 'invoice',
    paymentFailedVendor: 'invoice',
    payoutDepositedVendor: 'payout',
    relationshipUpdatedWithChanges: 'agreement'
};
export function pickSkeleton(notificationName) {
    var _SKELETON_BY_NOTIFICATION_notificationName;
    return (_SKELETON_BY_NOTIFICATION_notificationName = SKELETON_BY_NOTIFICATION[notificationName]) !== null && _SKELETON_BY_NOTIFICATION_notificationName !== void 0 ? _SKELETON_BY_NOTIFICATION_notificationName : null;
}
export function useNotificationParagraphs(message, apiVariables, context) {
    return useMemo(()=>{
        const parts = message.split('\n');
        return parts.map((paragraph)=>resolveSegments(paragraph, apiVariables, context));
    }, [
        message,
        apiVariables,
        context
    ]);
}
